<ion-header *ngIf="!device.isMobile()">
  <ion-toolbar>
    <ion-title>{{ dialogTitle || ("PUZZLE.win_dialog.title" | translate) }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row class="puzzle-modal-grow">
      <!--      <ion-col [size]="(leaderboard.leaderboardEnabled$|async) ? '5' : 'auto'">-->
      <ion-col>
        <ion-item lines="none" class="content-item">
          <div #inject></div>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="(leaderboard.leaderboardEnabled$|async) && showLeaderboard">
      <ion-col>
        <lib-app-leaderboard-win-dialog />
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-item class="puzzle-changer" lines="none">
        <lib-app-puzzle-changer-form
          [hideApplyButton]="true"
          [displayLanguagePicker]="false"
          class="puzzle-changer-form"
        />
      </ion-item>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <div class="puzzle-modal-buttons">
    <ion-button
      color="primary"
      *ngIf="showBackButton"
      (click)="closeDialog(false)"
      fill="solid"
    >
      <span>{{ "PUZZLE.win_dialog.back_to_game" | translate }}</span>
      <ion-icon slot="start" name="backspace-sharp" />
    </ion-button>

    <ion-button
      color="primary"
      *ngIf="showRestartButton"
      (click)="closeDialog(true)"
      fill="solid"
    >
      <span>{{ "PUZZLE.win_dialog.play_again" | translate }}</span>
      <ion-icon slot="end" name="refresh-sharp" />
    </ion-button>

    <ion-button
      color="primary"
      *ngIf="showScreenshotButton"
      [disabled]="screenshotPending"
      (click)="makeScreenshot()"
      fill="solid"
    >
      <span>{{ "PUZZLE.win_dialog.print_puzzle" | translate }}</span>
      <ion-icon slot="end" name="print-sharp" />
    </ion-button>

    <ion-button color="primary" (click)="sendSolutionWord()" fill="solid" *ngIf="sweepstakeEnabled">
      <span>{{ "PUZZLE.win_dialog.send_solution" | translate }}</span>
      <ion-icon slot="end" name="send-sharp" />
    </ion-button>

  </div>
</ion-footer>


<!--<div class="win-dialog">-->
<!--&lt;!&ndash;  <h1 mat-dialog-title class="color-primary">&ndash;&gt;-->
<!--&lt;!&ndash;    {{dialogTitle || ("PUZZLE.win_dialog.title" | translate )}}&ndash;&gt;-->
<!--&lt;!&ndash;  </h1>&ndash;&gt;-->

<!--&lt;!&ndash;  <div mat-dialog-content class="win-dialog-content">&ndash;&gt;-->
<!--&lt;!&ndash;    &lt;!&ndash; innerHTML directive instead of {{}}} so we can have line breaks in translation string. https://stackoverflow.com/a/45819206/4396362&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;    &lt;!&ndash;  <p class="puzzle-win-message"&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;    &lt;!&ndash;     [innerHTML]="dialogMessage || ('PUZZLE.win_dialog.message' | translate:{ solutionword: solutionWord, duration: duration, moveCounter: moveCounter })"></p>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;    &lt;!&ndash;  <p *ngIf="descriptionHTML" class="puzzle-win-description-html" [innerHTML]="descriptionHTML"></p>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;    <p #inject></p>&ndash;&gt;-->
<!--&lt;!&ndash;    <div class="win-dialog-spacer"></div>&ndash;&gt;-->
<!--&lt;!&ndash;  </div>&ndash;&gt;-->


<!--</div>-->

